import React from 'react';
import { Button, Grid, Typography } from '@mui/material';
import { useAccount } from '../../../contexts/Account';
import ProfileItemEmptyState from '../Profile/components/ProfileItemEmptyState';
import eventBus, { eventBusValues } from '../../../eventBus';
import ServicesChip from './ServicesChip';
import ServicesButton from './ServicesButton';

const useStyles = () => ({
  subtitle: {
    margin: '30px 0px 10px',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '20px',
    lineHeight: '24px',
    letterSpacing: -0.43,
    color: '#232B35',
  },
  serviceCard: {
    border: '1px solid #EFF0F7',
    borderRadius: '12px',
    width: '330px',
    padding: '24px',
    margin: '14px 15px 14px 0px',
  },
});

function Services(props) {
  const { isFreeTrial, isFreemium } = useAccount();
  const { services, advisor, isOwnProfile, legacy, publicProfile } = props;

  const { givenName } = advisor;
  const classes = useStyles();
  const hideServices = !isOwnProfile && advisor.freeTrialEndsOn;

  function openModal() {
    eventBus.dispatch(eventBusValues.triggerCompanyUpgradeAction, {
      servicesText: true,
    });
  }

  return (
    <>
      {services && services.length && !hideServices ? (
        <div
          style={{ margin: publicProfile ? null : '30px' }}
          id="advisor-services"
        >
          <Typography sx={classes.subtitle}>
            {givenName}'s Advisory Services
            {isOwnProfile && isFreeTrial && !isFreemium && !legacy && (
              <ServicesButton
                clickAction={openModal}
                sx={{ display: { xxs: 'none', xs: 'inline-flex' } }}
              />
            )}
          </Typography>
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '24px',
              letterSpacing: '-0.43px',
              color: '#646D7A',
              marginBottom: '11px',
            }}
          >
            {givenName} is available as an advisor, or for project-based work
            related to the following services:
          </Typography>

          {isOwnProfile && isFreeTrial && !isFreemium && !legacy && (
            <ServicesButton
              clickAction={openModal}
              sx={{
                height: '32px',
                width: '100%',
                display: { xxs: 'inline-flex', xs: 'none' },
              }}
            />
          )}
          <Grid
            container
            style={{
              marginBottom: '10px',
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            {services.map((service, index) => (
              <div
                id={`advisor-service-${index + 1}`}
                className="advisor-service-card"
                key={index}
                style={classes.serviceCard}
              >
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: '14px',
                    lineHeight: '24px',
                    letterSpacing: '-0.43px',
                    color: '#646D7A',
                    marginBottom: '11px',
                  }}
                >
                  {service.description}
                </Typography>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div></div>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: '16px',
                      lineHeight: '24px',
                    }}
                  >
                    {new Intl.NumberFormat('en-US', {
                      style: 'currency',
                      currency: 'USD',
                    }).format(service.price)}
                  </Typography>
                </div>

                {isOwnProfile && isFreeTrial && !isFreemium && !legacy && (
                  <ServicesChip clickAction={openModal} />
                )}
              </div>
            ))}
          </Grid>
        </div>
      ) : null}

      {(!services || services.length === 0) &&
        props.isOwnProfile &&
        !publicProfile && (
          <>
            <ProfileItemEmptyState
              title="Advisory Services"
              subtitle="Your Advisory Services will appear here once you have added one."
              mainBoxStyle={{
                margin: '30px',
              }}
            />
            <Grid
              container
              style={{
                margin: '20px 30px 30px',
                marginBottom: '10px',
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <div
                className="advisor-service-card"
                style={{
                  ...classes.serviceCard,
                  height: '130px',
                  marginTop: '0px',
                }}
              >
                <ProfileItemEmptyState
                  logs
                  items={[
                    {
                      width: '100%',
                    },
                    {
                      width: '100%',
                    },
                    {
                      width: '25%',
                      align: 'end',
                    },
                  ]}
                />
              </div>
              <div
                className="advisor-service-card"
                style={{
                  ...classes.serviceCard,
                  height: '130px',
                  marginTop: '0px',
                }}
              >
                <ProfileItemEmptyState
                  logs
                  items={[
                    {
                      width: '100%',
                    },
                    {
                      width: '100%',
                    },
                    {
                      width: '25%',
                      align: 'end',
                    },
                  ]}
                />
              </div>
            </Grid>
          </>
        )}
    </>
  );
}

export default Services;
